import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { State } from '@app/store/state/state';
import {
  clearFlightResultsCabinAction, fetchFlightCabinAction, fetchFlightResultsCabinAction
} from '@flight-results/store/actions/flights-results.actions';
import { FlightAmenitieResultItem } from '@app/entities/flight-results';
import { getUiFlightsState } from './store/selectors/ui.selector';
import { UiFlightsState } from '@flight-results/store/state/flight-results-module.state';
import { flightResultsRootSelector } from '@flight-results/store/selectors/flight-results-root.selector';
import { FlightCabin, FlightDetailCabinPayload, FlightResultsCabinPayload } from '@shared/flight-itinerary/entities/cabin-types';

@Injectable({providedIn: 'root'})
export class FlightResultsCabinFacade {

  constructor(protected store: Store<State>) { }

  public isLoadingFlightCabin$: Observable<boolean> = this.store
    .pipe(
      select(getUiFlightsState),
      map((state: UiFlightsState) => state?.isLoadingFlightCabin)
    );

  public flightCabinSelected$: Observable<FlightCabin> = this.store
    .pipe(
      select(flightResultsRootSelector),
      map(state => state?.flightCabinSelected)
    );

  public isLoadingFlightCabinDetail$: Observable<boolean> = this.store
    .pipe(
      select(getUiFlightsState),
      map((state: UiFlightsState) => state?.isLoadingFlightCabinDetail)
    );

  public flightCabinsDetailSelected$: Observable<FlightAmenitieResultItem[]> = this.store
    .pipe(
      select(flightResultsRootSelector),
      map(state => state?.flightCabinDetailSelected),
    );

  public selectFlightCabin(payload: FlightDetailCabinPayload): void {
    this.store.dispatch(fetchFlightCabinAction({ payload }));
  }

  public fetchFlightResultsCabin(payload: FlightResultsCabinPayload): void {
    this.store.dispatch(fetchFlightResultsCabinAction({ payload }));
  }

  public clearFlightResultsCabin(): void {
    this.store.dispatch(clearFlightResultsCabinAction());
  }
}
